
import { 
	call, 
	takeLatest, 
	put 
} from 'redux-saga/effects'

import {
  SEND_EMAIL,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAIL
} from '../Constants'

import Notification from "../../../components/commons/Notification"

function* sendEmail(action) {
	const { name, lastname, email, phone_number, message, service_type } = action.payload.body
  return yield fetch(
    process.env.REACT_APP_EMAIL_API_URL,
    {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer '+process.env.REACT_APP_EMAIL_API_KEY
			},
			mode: 'cors',
			body: JSON.stringify({
				from: 'hello@intivastudio.com',
				to: ["contacto@organizacionlb.com.ar", "jenny@intivastudio.com", "enzo@intivastudio.com"],
				replyTo: email,
				subject: `Consulta web: ${service_type}`,
				html: `<p><strong>¿Es productor?</strong> ${service_type}</p>
				       <p><strong>Nombre:</strong> ${name} ${lastname}</p>
				       <p><strong>Email:</strong> ${email}</p>
				       <p><strong>Celular:</strong> ${phone_number}</p>
				       <p><strong>Mensaje:</strong> ${message ? message : 'Sin mensaje'}</p>`
			})
    }
  )
}

export function* shootFetchSendEmail(action) {
  try {
		yield console.log(action)
    const response  = yield call(sendEmail, action)
		const emailData = yield response.json()
		let type
    if (response.status >= 200 && response.status < 300) {
      type = SEND_EMAIL_SUCCESS
			yield Notification('El mail se ha enviado correctamente', 'success')
    }
    else {
	  	type = SEND_EMAIL_FAIL
	 		yield Notification(`Tuvimos un problema: ${response.statusText}`, 'error')
    }
		yield put({type: type, payload: emailData})
  }
  catch (error) {
    yield put({ type: SEND_EMAIL_FAIL, payload: error.message})
		yield Notification(`Tuvimos un problema: ${error.message}`, 'error')
  }
}

export default function* sendEmailWatcher() {
  yield takeLatest(SEND_EMAIL, shootFetchSendEmail)
}
